import React, { useRef, useState } from "react";
import { SectionEntity } from "@/database";
import { getHostLogoStyleByHostId } from "@/utils";
import { useClickOutside } from "@/utils";
import { truncateText } from "@/utils/utilFunctions/truncateText";

type Props = {
  globalFavSectionList: SectionEntity[];
  hosts: any[];
  hostOptions: any[];
  denmarkHosts: any[];
  selectedHost: string;
  onSelect: (section: SectionEntity) => void;
};

const FavSectionChips: React.FC<Props> = ({
  globalFavSectionList,
  hosts,
  hostOptions,
  denmarkHosts,
  selectedHost,
  onSelect,
}) => {
  const [open, setOpen] = useState(false);
  const popoverRef = useRef<HTMLDivElement>(null);

  useClickOutside(popoverRef, () => setOpen(false));

  if (!globalFavSectionList || globalFavSectionList.length === 0) return null;

  const logoStyle = getHostLogoStyleByHostId(
    Number(selectedHost),
    hosts,
    hostOptions,
    denmarkHosts
  );

  return (
    <div style={{ position: "relative" }} ref={popoverRef}>
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        style={{
          background: "none",
          border: "none",
          padding: "4px 0",
          fontSize: "12px",
          fontWeight: 600,
          color: "#2a7ae2",
          cursor: "pointer",
          letterSpacing: "0.01em",
        }}
      >
        Favourite Sections
      </button>

      {open && (
        <div
          style={{
            position: "absolute",
            top: "100%",
            right: "100%",
            zIndex: 1050,
            background: "#fff",
            border: "1px solid #dde3e8",
            borderRadius: "8px",
            boxShadow: "0 6px 24px rgba(0,0,0,0.13)",
            minWidth: "260px",
            maxWidth: "340px",
            maxHeight: "260px",
            overflowY: "auto",
            padding: "6px",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "6px",
              padding: "4px 2px",
            }}
          >
            {globalFavSectionList.map((section) => (
              <div
                key={section.msId}
                className="social-chip gap-1 p-1"
                style={{
                  cursor: "pointer",
                  width: "fit-content",
                  minWidth: "70px",
                }}
                onClick={() => {
                  onSelect(section);
                  setOpen(false);
                }}
              >
                <div className="d-flex align-items-center gap-1">
                  <div style={logoStyle} />
                  <span
                    className="text-truncate flex-grow-1"
                    style={{ fontSize: "12px" }}
                  >
                    {truncateText(section.name || section.aliasName, 25)}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default FavSectionChips;
